import React from "react";
import PropTypes from "prop-types";
import Select from "../../../../../../form/component/Select";
import {PHOTO_REJECTION_REASONS} from "../../../../../state/task-widget/const";

const reasonsDropdownStyle = {
    height: "28px"
};

const getLatestImageVersion = (imageVersionList) => {
    return imageVersionList.length !== 0 ? imageVersionList[imageVersionList.length - 1] : null;
}

const getValues = () => {
    return PHOTO_REJECTION_REASONS.map(image => ({
        id: image.name,
        value: image.title,
    }))
}

const findSelectedImageVersion = (selectedImageVersions, preCheckinPhotoIndex, imageVersionList) => {
    let result = null;

    for (const selectedImageVersion of selectedImageVersions) {
        if (selectedImageVersion.preCheckinPhotoIndex === preCheckinPhotoIndex && imageVersionList !== undefined) {
            result = {
                enabled: imageVersionList.length - 1 === selectedImageVersion.imageVersionIndexInGallery,
                imageVersion: imageVersionList[selectedImageVersion.imageVersionIndexInGallery]
            }
            break;
        }
    }

    if (result === null) {
        result = {
            enabled: true,
            imageVersion: getLatestImageVersion(imageVersionList)
        }
    }

    return result;
}

const Dropdown = ({
                      setPhotoRejectionReason,
                      selectedImageVersions,
                      preCheckinPhotoIndex,
                      imageVersionList,
                  }) => {
    let {enabled, imageVersion} = findSelectedImageVersion(selectedImageVersions, preCheckinPhotoIndex, imageVersionList);

    return (
        <div style={{marginTop: "20px"}}>
            <p>Photo issue</p>
            <Select
                readOnly={!enabled}
                style={reasonsDropdownStyle}
                object={{}}
                name="name"
                addEmpty={true}
                valueList={getValues()}
                defaultValue={imageVersion && imageVersion.meta !== null ? imageVersion.meta.reason : ""}
                onChange={(name, newPhotoNeededReason) => {
                    setPhotoRejectionReason(imageVersion, newPhotoNeededReason)
                }}
            />
        </div>
    )
};

Dropdown.propTypes = {
    setPhotoRejectionReason: PropTypes.func.isRequired,
    selectedImageVersions: PropTypes.array,
    preCheckinPhotoIndex: PropTypes.number,
    imageVersionList: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
};

export default Dropdown;


// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/customerPreCheckinImageWidget/components/Dropdown/Dropdown.js